import { LoginInfo, FavoriteQueryParam, ID } from '@/types/type';

export const addFavorites = (param: FavoriteQueryParam) => {
  const getAddFavoritesContent = (
    loginInfo: LoginInfo,
    menuId: string,
    index: number
  ): string => {
    return `
      result${index}: createFavorite(input: {
        menuId: "${menuId}",
        sort: ${index},
        loginName: "${loginInfo.loginName}",
        tenant: "${loginInfo.tenant}",
        landscape: "${loginInfo.landscape}",
      }) {
        sort
        menuId
      }
    `;
  };
  const content: string = param.menuIds
    .map((id: ID, index: number) => {
      return getAddFavoritesContent(param, id, index);
    })
    .join('');
  return `
    mutation CreateFavorite {
      ${content}
    }
  `;
};

export const deleteFavorites = (param: FavoriteQueryParam) => {
  const getDeleteFavoritesContent = (
    loginInfo: LoginInfo,
    menuId: string,
    index: number
  ): string => {
    return `
      result${index}: deleteFavorite(input: {
        menuId: "${menuId}",
        loginName: "${loginInfo.loginName}",
        tenant: "${loginInfo.tenant}",
        landscape: "${loginInfo.landscape}",
      }) {
        sort
        menuId
      }
    `;
  };
  const content: string = param.menuIds
    .map((id: ID, index: number) => {
      return getDeleteFavoritesContent(param, id, index);
    })
    .join('');
  return `
      mutation DeleteFavorite {
        ${content}
      }
  `;
};
